import { render } from "./AccountReasons.vue?vue&type=template&id=0316f1bc&scoped=true"
import script from "./AccountReasons.vue?vue&type=script&lang=js"
export * from "./AccountReasons.vue?vue&type=script&lang=js"

import "./AccountReasons.vue?vue&type=style&index=0&id=0316f1bc&scoped=true&lang=css"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0316f1bc"]])

export default __exports__